var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import SelectSurveyForm from "./SelectSurveyForm";
import PersonService from "../../../Services/Person.service";
import { AlertInfo, AlertSuccess, } from "../../UI/StandardAlerts/StandardAlerts";
import FAIcon from "../../UI/FAIcon/FAIcon";
import SurveyService from "../../../Services/Survey.service";
import useService from "../../Hooks/useService";
const TakeSurveyModal = (_a) => {
    var { regardingPerson, onSend } = _a, modalProps = __rest(_a, ["regardingPerson", "onSend"]);
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const [takeSurveyUrl, setTakeSurveyUrl] = React.useState(null);
    React.useEffect(() => {
        if (!modalProps.isOpen) {
            setTakeSurveyUrl(null);
        }
    }, [modalProps.isOpen]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Take Survey", keepModalOpenAfterSuccess: true, saveButtonContents: (loading) => (_jsxs(_Fragment, { children: [_jsx(FAIcon, { icon: "edit", isLoading: loading, addMarginRight: true }), "Take"] })), handleSubmit: (state) => me.data
            ? SurveyService.takeSurvey({
                surveyId: state.survey.id,
                regardingPersonId: regardingPerson.personId,
                recipientPersonId: me.data.personId,
            }).then((response) => {
                if (onSend) {
                    onSend(response);
                    setTakeSurveyUrl(response.takeSurveyUrl);
                    window.open(response.takeSurveyUrl, "_blank");
                }
            })
            : Promise.reject("Error loading your user information.  Please try again."), children: (useFormProps) => (_jsxs(_Fragment, { children: [_jsx(SelectSurveyForm, Object.assign({}, useFormProps)), _jsx(AlertInfo, { message: `The survey results will appear on the Surveys tab for ${regardingPerson.fullName}.` }), takeSurveyUrl && (_jsx(AlertSuccess, { message: _jsxs("span", { children: ["A new browser window or tab has been opened to the survey URL. If it did not open, please click the following link to take the survey.", " ", _jsx("a", { target: "_blank", rel: "noopener noreferrer", href: takeSurveyUrl, children: takeSurveyUrl })] }) }))] })) })));
};
export default TakeSurveyModal;
